(function(){
  document.querySelectorAll('[data-mo-pdp]').forEach(function(root){
    if(root.dataset.moInit) return;
    root.dataset.moInit = '1';

    var mq = window.matchMedia('(max-width:920px)');

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var stage = root.querySelector('[data-stage]');
    var counterCur = root.querySelector('[data-counter-cur]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dots] .mo-pdp__gdot'));

    function activate(idx){
      slides.forEach(function(s,i){ s.classList.toggle('is-active', i===idx); });
      thumbs.forEach(function(t,i){
        var on = i===idx;
        t.classList.toggle('is-active', on);
        if(on){ t.setAttribute('aria-current','true'); } else { t.removeAttribute('aria-current'); }
        if(on && t.scrollIntoView){ try{ t.scrollIntoView({block:'nearest'}); }catch(e){} }
      });
      dots.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); });
      if(counterCur) counterCur.textContent = (idx+1);
      syncZoomable();
    }

    thumbs.forEach(function(t,i){
      t.addEventListener('click', function(){ activate(i); });
    });

    if(stage){
      stage.addEventListener('scroll', function(){
        if(!mq.matches) return;
        var idx = Math.round(stage.scrollLeft / stage.clientWidth);
        if(idx < 0) idx = 0;
        if(idx > slides.length - 1) idx = slides.length - 1;
        activate(idx);
      }, {passive:true});
    }

    function activeSlide(){
      for(var i=0;i<slides.length;i++){ if(slides[i].classList.contains('is-active')) return slides[i]; }
      return null;
    }
    function slideZoomable(s){
      if(!s) return false;
      var w = parseInt(s.getAttribute('data-w'),10);
      return !isNaN(w) && w >= 700;
    }
    function syncZoomable(){
      if(!stage) return;
      stage.classList.toggle('is-zoomable', slideZoomable(activeSlide()));
    }
    syncZoomable();

    var zoomMq = window.matchMedia('(min-width:921px) and (hover:hover) and (pointer:fine)');
    if(stage && zoomMq.matches){
      var zoomTimer;
      var setOrigin = function(e){
        var r = stage.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        var img = stage.querySelector('.mo-pdp__slide.is-active img');
        if(img) img.style.transformOrigin = x + '% ' + y + '%';
      };
      stage.addEventListener('mouseenter', function(e){
        if(!slideZoomable(activeSlide())) return;
        setOrigin(e);
        clearTimeout(zoomTimer);
        zoomTimer = setTimeout(function(){ stage.classList.add('is-zoomed'); }, 140);
      });
      stage.addEventListener('mousemove', function(e){ if(stage.classList.contains('is-zoomed')) setOrigin(e); });
      stage.addEventListener('mouseleave', function(){ clearTimeout(zoomTimer); stage.classList.remove('is-zoomed'); });
    }

    var lb = root.querySelector('[data-lightbox]');
    var lbImg = root.querySelector('[data-lb-img]');
    var lbLastFocus = null;
    function openLightbox(){
      if(!lb || !lbImg) return;
      var s = activeSlide();
      if(!s) return;
      var src = s.getAttribute('data-full');
      if(!src){
        var im = s.querySelector('img');
        src = im ? (im.currentSrc || im.src) : null;
      }
      if(!src) return;
      lbLastFocus = document.activeElement;
      lbImg.src = src;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = lb.querySelector('[data-lb-close]');
      if(x) x.focus();
    }
    function closeLightbox(){
      if(!lb) return;
      lb.hidden = true;
      if(lbImg) lbImg.removeAttribute('src');
      document.documentElement.style.overflow = '';
      if(lbLastFocus && lbLastFocus.focus){ try{ lbLastFocus.focus(); }catch(e){} }
      lbLastFocus = null;
    }
    if(stage && lb){
      stage.addEventListener('click', function(e){
        /* Buyutec her ekranda calissin (2026-08-06). Eskiden `if(!mq.matches) return;`
           ile SADECE mobilde aciliyordu; masaustunde gorseli buyutmenin hicbir yolu
           yoktu — tek yakinlastirma 1,6x hover zoom'du ve ~720px'lik dosyayi buyuttugu
           icin bulaniyordu. Boya kutusunun etiketini ya da matkap ucunun olcusunu
           okumak isteyen musteri icin gercek kayipti. Lightbox zaten Esc + odak tuzagi
           ile hazirdi ve masaustunde de calisiyor. */
        /* Buyutec dugmesi (2026-08-06): eskiden aria-hidden + pointer-events:none olan
           bir sus ogesiydi; artik gercek bir <button>. Klavyeyle Tab ile ulasilip Enter
           ile aciliyor — WCAG 2.1.1. Dugme .mo-pdp__slide DISINDA, stage'in dogrudan
           cocugu oldugu icin asagidaki slayt kontrolüyle cakismaz, cift acilma olmaz. */
        if(e.target && e.target.closest && e.target.closest('[data-lb-open]')){
          openLightbox();
          return;
        }
        if(e.target && e.target.closest && e.target.closest('.mo-pdp__slide') && !e.target.closest('.mo-pdp__slide--ph')){
          openLightbox();
        }
      });
      lb.addEventListener('click', function(e){
        if(e.target === lb || (e.target.closest && e.target.closest('[data-lb-close]'))) closeLightbox();
      });
      document.addEventListener('keydown', function(e){
        if(lb.hidden) return;
        if(e.key === 'Escape'){ closeLightbox(); return; }
        if(e.key === 'Tab'){
          var f = Array.prototype.slice.call(
            lb.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select,[tabindex]:not([tabindex="-1"])')
          ).filter(function(el){ return el.offsetParent !== null; });
          if(!f.length){ e.preventDefault(); return; }
          var first = f[0], last = f[f.length-1];
          if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
          else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
          else if(f.indexOf(document.activeElement) === -1){ e.preventDefault(); first.focus(); }
        }
      });
    }

    var qty = root.querySelector('[data-qty]');
    function clampQty(v){ v = parseInt(v,10); if(isNaN(v)||v<1) v=1; if(v>99) v=99; return v; }
    var qminus = root.querySelector('[data-qminus]');
    var qplus = root.querySelector('[data-qplus]');
    if(qminus) qminus.addEventListener('click', function(){ qty.value = clampQty(qty.value - 1); });
    if(qplus) qplus.addEventListener('click', function(){ qty.value = clampQty(parseInt(qty.value,10) + 1); });
    if(qty) qty.addEventListener('change', function(){ qty.value = clampQty(qty.value); });

    var OPEN = String.fromCharCode(123,123);
    var CLOSE = String.fromCharCode(125,125);
    var moneyFormat = root.getAttribute('data-money-format') || ('€' + OPEN + 'amount' + CLOSE);
    function tokenRe(name){ return new RegExp(OPEN + '\\s*' + name + '\\s*' + CLOSE); }
    function formatMoney(cents){
      var value = (cents/100).toFixed(2).replace('.', ',');
      var parts = value.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      value = parts.join(',');
      return moneyFormat
        .replace(tokenRe('amount'), value)
        .replace(tokenRe('amount_with_comma_separator'), value)
        .replace(tokenRe('amount_no_decimals'), parts[0]);
    }

    var variantBtns = Array.prototype.slice.call(root.querySelectorAll('[data-variant]'));
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var codeEl = root.querySelector('[data-code]');
    var codeWrap = root.querySelector('[data-code-wrap]');
    var codeSep = root.querySelector('[data-code-sep]');
    var stickyCodeEl = root.querySelector('[data-sticky-code]');
    var eanEl = root.querySelector('[data-ean]');
    var eanWrap = root.querySelector('[data-ean-wrap]');
    var addBtn = root.querySelector('[data-add]');
    var stickyAddBtn = root.querySelector('[data-sticky-add]');
    var oldPriceEl = root.querySelector('[data-old-price]');
    var saveTagEl = root.querySelector('[data-savetag]');
    var savePctEl = root.querySelector('[data-save-pct]');
    var saveAmtEl = root.querySelector('[data-save-amt]');
    var stickyOldEl = root.querySelector('[data-sticky-old]');
    var vatNoteEl = root.querySelector('[data-vat-rate]');
    var vatAmountEl = root.querySelector('[data-vat-amount]');
    var stockInEl = root.querySelector('[data-stock-in]');
    var stockOutEl = root.querySelector('[data-stock-out]');
    var stickyAvailEl = root.querySelector('[data-sticky-avail]');

    function setText(el, val){ if(el) el.textContent = val; }
    function setHidden(el, hide){ if(el){ if(hide){ el.setAttribute('hidden',''); } else { el.removeAttribute('hidden'); } } }

    function priceString(btn, cents){
      var pre = btn.getAttribute('data-price-formatted');
      if(pre) return pre;
      return isNaN(cents) ? null : formatMoney(cents);
    }

    function selectVariant(btn){
      variantBtns.forEach(function(b){
        b.classList.toggle('is-active', b===btn);
        b.setAttribute('aria-pressed', b===btn ? 'true' : 'false');
      });
      if(idInput) idInput.value = btn.getAttribute('data-id');

      var cents = parseInt(btn.getAttribute('data-price'),10);
      var compare = parseInt(btn.getAttribute('data-compare'),10);
      var priceStr = priceString(btn, cents);
      if(priceStr){ setText(priceEl, priceStr); setText(stickyPrice, priceStr); }

      /* Varyant degisince KDV tutari da degisir. Fiyatlar KDV DAHIL girildigi icin
         KDV = fiyat − fiyat/(1+oran). Oran vatNote uzerindeki data-vat-rate'ten gelir
         (tema ayari), boylece oran degisirse JS'e dokunmak gerekmiyor. */
      if(vatAmountEl && !isNaN(cents)){
        var rate = parseFloat(vatNoteEl && vatNoteEl.getAttribute('data-vat-rate')) || 24;
        var net = Math.round(cents * 100 / (100 + rate));
        setText(vatAmountEl, formatMoney(cents - net));
      }

      var pctVal = (!isNaN(compare) && !isNaN(cents) && compare > cents) ? Math.round((compare - cents) * 100 / compare) : 0;
      var onSale = pctVal >= 1;
      var compareStr = btn.getAttribute('data-compare-formatted');
      var saveStr = btn.getAttribute('data-save-formatted');
      if(onSale){
        if(compareStr){ setText(oldPriceEl, compareStr); setText(stickyOldEl, compareStr); }
        setHidden(oldPriceEl, false);
        setHidden(stickyOldEl, false);
        setHidden(saveTagEl, false);
        if(savePctEl){ savePctEl.textContent = pctVal; }
        if(saveAmtEl && saveStr){ saveAmtEl.textContent = saveStr; }
      } else {
        setHidden(oldPriceEl, true);
        setHidden(stickyOldEl, true);
        setHidden(saveTagEl, true);
      }

      /* Κωδικός / EAN: varyantta yoksa etiketi de gizle.
         (Once bos string yaziliyordu → ekranda «Κωδικός:» yalniz kaliyordu.) */
      var sku = btn.getAttribute('data-sku') || '';
      var bc = btn.getAttribute('data-barcode') || '';
      setText(codeEl, sku);
      setText(stickyCodeEl, sku);
      setText(eanEl, bc);
      setHidden(codeWrap, !sku);
      setHidden(eanWrap, !bc);
      setHidden(codeSep, !(sku && bc));

      /* 2026-08-06: `data-stock` ozniteligi kaldirildi — `data-available` ile birebir ayni
         bilgiyi tasiyordu. 'low' dali da silindi: sunucu tarafinda stock_state hicbir zaman
         'low' uretmiyordu, yani bu dal ulasilamazdi.
         Metin «Άμεσα διαθέσιμο» → «Διαθέσιμο»: magazada 3.296 urunden yalnizca 7'sinde stok
         takibi acik, «hemen» sozunun arkasi yoktu. Ayni kelime uc yerde daha geciyor
         (mo-product.liquid rozet + stock_label, mo-card.liquid) — dordu birden tutmali,
         yoksa varyant degistirir degistirmez eski soz geri gelir. */
      var avail = btn.getAttribute('data-available') === 'true';
      var state = avail ? 'in' : 'out';
      setHidden(stockInEl, state !== 'in');
      setHidden(stockOutEl, state !== 'out');
      setText(stickyAvailEl, state === 'in' ? 'Διαθέσιμο' : 'Εξαντλημένο');
      [addBtn, stickyAddBtn].forEach(function(b){ if(b) b.disabled = !avail; });

      /* Varyantin kendi fotografi varsa galeriyi ona cevir */
      var mi = parseInt(btn.getAttribute('data-media'), 10);
      if(!isNaN(mi) && mi >= 0 && mi < slides.length){
        activate(mi);
        if(mq.matches && stage){
          try{ stage.scrollTo({left: mi * stage.clientWidth, behavior:'smooth'}); }
          catch(e){ stage.scrollLeft = mi * stage.clientWidth; }
        }
      }

      /* URL'yi ?variant= ile guncelle: paylasilan/geri gidilen adres dogru
         varyanti acsin (Skroutz ve reklam baglantilari da bunu kullanir).
         replaceState — her tiklama geri tusuna yeni adim eklemesin. */
      var vurl = btn.getAttribute('data-url');
      if(vurl && window.history && history.replaceState){
        try{ history.replaceState({moVariant:1}, '', vurl); }catch(e){}
      }
    }

    variantBtns.forEach(function(btn){
      btn.addEventListener('click', function(){ selectVariant(btn); });
    });

    var form = root.querySelector('.mo-pdp__form');
    var toast = root.querySelector('[data-toast]');
    var toastMsg = root.querySelector('[data-toast-msg]');
    var toastTimer;
    function showToast(msg){
      if(!toast) return;
      if(toastMsg) toastMsg.textContent = msg;
      toast.hidden = false;
      requestAnimationFrame(function(){ toast.classList.add('is-show'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function(){
        toast.classList.remove('is-show');
        setTimeout(function(){ toast.hidden = true; }, 240);
      }, 2600);
    }

    function updateCartCount(){
      fetch('/cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){
          document.querySelectorAll('.mo-cart .mo-badge, [data-cart-count], .cart-count').forEach(function(el){
            el.textContent = cart.item_count;
          });
        }).catch(function(){});
    }

    var addLabel = root.querySelector('[data-add-label]');
    var addLabelOrig = addLabel ? addLabel.textContent : '';
    var addLabelTimer;
    function flashAdded(){
      if(!addLabel) return;
      addLabel.textContent = '✓ Προστέθηκε';
      clearTimeout(addLabelTimer);
      addLabelTimer = setTimeout(function(){ addLabel.textContent = addLabelOrig; }, 2200);
    }

    function addToCart(opts){
      opts = opts || {};
      if(!form) return;
      if(!window.fetch){ form.submit(); return; }
      var data = new FormData(form);
      if(addBtn){ addBtn.classList.add('is-loading'); addBtn.disabled = true; }
      if(opts.btn && opts.btn !== addBtn){ opts.btn.classList.add('is-loading'); opts.btn.disabled = true; }
      return fetch('/cart/add.js', {
        method:'POST',
        headers:{'Accept':'application/json'},
        body:data
      }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
        .then(function(res){
          if(res.ok){
            if(opts.checkout){ window.location.href = '/checkout'; return; }
            /* 2026-08-06: tek olay icin uc bildirim vardi — cekmece acilir, siyah
               toast cikar, buton yazisi degisir. Toast kaldirildi; onayi cekmece ve
               buton veriyor. showToast yalnizca HATA icin kullaniliyor artik. */
            flashAdded();
            updateCartCount();
            document.dispatchEvent(new CustomEvent('mo:cart:added'));
          } else {
            showToast((res.body && res.body.description) || 'Δεν ήταν δυνατή η προσθήκη στο καλάθι');
          }
        }).catch(function(){
          showToast('Σφάλμα σύνδεσης — δοκίμασε ξανά');
        }).then(function(){
          if(addBtn){ addBtn.classList.remove('is-loading'); addBtn.disabled = false; }
          if(opts.btn && opts.btn !== addBtn){ opts.btn.classList.remove('is-loading'); opts.btn.disabled = false; }
        });
    }

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        addToCart({btn:addBtn});
      });
    }

    if(stickyAddBtn){
      stickyAddBtn.addEventListener('click', function(){ addToCart({btn:stickyAddBtn}); });
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var accs = Array.prototype.slice.call(root.querySelectorAll('[data-acc]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.mo-pdp__panel'));
    var keys = tabs.map(function(t){ return t.getAttribute('data-tab'); });

    function showSection(key){
      tabs.forEach(function(t){
        var on = t.getAttribute('data-tab') === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      accs.forEach(function(a){
        var on = a.getAttribute('data-acc') === key;
        a.classList.toggle('is-open', on);
        a.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function(p){
        var on = p.id === 'mo-p-' + key;
        p.classList.toggle('is-active', on);
        p.classList.toggle('is-open', on);
      });
    }

    tabs.forEach(function(t){
      t.addEventListener('click', function(){ showSection(t.getAttribute('data-tab')); });
      t.addEventListener('keydown', function(e){
        var idx = keys.indexOf(t.getAttribute('data-tab'));
        var ni = null;
        if(e.key==='ArrowRight'||e.key==='ArrowDown') ni = (idx+1)%keys.length;
        else if(e.key==='ArrowLeft'||e.key==='ArrowUp') ni = (idx-1+keys.length)%keys.length;
        else if(e.key==='Home') ni = 0;
        else if(e.key==='End') ni = keys.length-1;
        if(ni!==null){ e.preventDefault(); showSection(keys[ni]); tabs[ni].focus(); }
      });
    });

    accs.forEach(function(a){
      a.addEventListener('click', function(){
        if(a.classList.contains('is-open')) return;
        showSection(a.getAttribute('data-acc'));
      });
    });

    var sticky = root.querySelector('[data-sticky]');
    /* 2026-08-17 — mobil dali kaldirildi.
       ONCEDEN: `if(mq.matches){ sticky.classList.add('is-show'); return; }`
       yani telefonda cubuk sayfa acilir acilmaz, scroll'a hic bakmadan
       goruntuleniyordu. Ustelik cubuk hangi varyantin eklenecegini
       soylemiyor. Cok varyantli uründe (boyada litre, alette olcu)
       kullanici seciciye hic bakmadan basabiliyor ve ILK varyant sepete
       giriyordu — iade/degisim surtunmesi ve guven kaybi.
       ARTIK: iki ekranda da ayni kural — cubuk, asil «sepete ekle» dugmesi
       ekrandan cikinca geliyor. Buton bulunamazsa eski 660px esigine duser
       (savunmaci: markup degisirse cubuk kaybolmasin). */
    var addBtn = root.querySelector('.mo-pdp__addcart') || root.querySelector('[name="add"]');
    function syncSticky(){
      if(!sticky) return;
      if(addBtn){
        sticky.classList.toggle('is-show', addBtn.getBoundingClientRect().bottom < 0);
        return;
      }
      var sc = window.scrollY || window.pageYOffset || 0;
      sticky.classList.toggle('is-show', sc > 660);
    }
    if(sticky){
      syncSticky();
      window.addEventListener('scroll', syncSticky, {passive:true});
      window.addEventListener('resize', syncSticky, {passive:true});
    }

    /* ---------- Σχετικά προϊόντα: Shopify oneri motoru (2026-08-06) ----------
       Eskiden bu bolum koleksiyonun ILK 4 urununu basiyordu, yani ayni alt
       kategorideki butun urunler birbirinin ayni 4 karti goruyordu (canlida
       dogrulandi). Artik Shopify her urun icin farkli oneri uretiyor.
       Isaretlemeyi sections/mo-recs.liquid dondurur.
       Bos donerse kap gizli kalir — sayfada bos bir baslik birakmayiz. */
    var recsBox = root.querySelector('[data-mo-recs]');
    if(recsBox && 'fetch' in window){
      var recsBase = recsBox.getAttribute('data-url') || '/recommendations/products';
      var recsPid = recsBox.getAttribute('data-product-id');
      if(recsPid){
        var recsUrl = recsBase
          + (recsBase.indexOf('?') === -1 ? '?' : '&')
          + 'section_id=mo-recs&product_id=' + encodeURIComponent(recsPid)
          + '&limit=4&intent=related';
        fetch(recsUrl, {headers:{Accept:'text/html'}})
          .then(function(r){ if(!r.ok) throw 0; return r.text(); })
          .then(function(html){
            /* Shopify bolumu bir kapsayiciyla sarar; yalniz kendi bolumumuzu aliriz. */
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var sec = doc.querySelector('.mo-pdp__related');
            if(!sec || !sec.querySelector('.mo-pdp__rcard')) return;
            recsBox.appendChild(document.importNode(sec, true));
            recsBox.hidden = false;
          })
          .catch(function(){ /* oneri gelmezse sayfa aynen calisir */ });
      }
    }
  });
})();
